import 'core-js/stable';
import 'core-js/stable/string/replace-all';
import 'regenerator-runtime/runtime';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Loading } from './components/shared/Loading';
import './index.css';

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <App />
  </Suspense>,
  document.getElementById('root')
);
